<ng-template #modalBlogForm let-modal>
  <div class="form-blog__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <h3 class="text-center">Form Blog</h3>
  <form [formGroup]="bottomImagesForm">
    <div class="upload-image">
      <input formControlName="banner" type="file" #banner (change)="onBottomBannerSelected(banner.files, $event)"
        accept="image/*" />
      <img loading="lazy" src="../../../assets/images/uploadd1.png" *ngIf="blogImageUrl == ''" />
      <img loading="lazy" src="{{ blogImageUrl }}" *ngIf="blogImageUrl != ''" />

    </div>

    <div class="my-input title-shepherd">
      <input type="text" placeholder="Title" formControlName="title" />
      <div class="line"></div>

    </div>
    <div class="form-group editor-shepherd">
      <app-editor [(innerValue)]="ckEditorText"></app-editor>
    </div>
    <div class="form-group">
      <textarea placeholder="Metadata" class="form-control" formControlName="metadata"></textarea>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="my-input author-shepherd">
          <input type="text" placeholder="Author" formControlName="author" />
          <div class="line"></div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="my-input category-shepherd">
          <select formControlName="category">
            <option value="" disabled selected>Select Section</option>
            <option *ngFor="let val of categoriesSelect" [value]="val">
              {{ val }}
            </option>
          </select>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <button class="my-button-3" style="margin: auto; display: flex" (click)="addBottomBanner()"><i
        class="fa-solid fa-save"></i> Submit</button>
  </form>
</ng-template>


<ng-template #modalBlogRelate let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Relate Article</h2>
    <div class="form-group">
      <label class="mb-0">Article</label>
      <select2 [data]="optionsRelated || []" [(ngModel)]="bottomBannerTarget" [placeholder]="'Select an item...'"
        [displaySearchStatus]="'always'"> </select2>
    </div>
    <button class="ml-auto d-flex my-button-3" (click)="addBottomBannerRelate()"><i class="fa-solid fa-save"></i>
      Submit</button>
  </div>
</ng-template>
<ng-template #modalBlogRelateRemove let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Remove Relate Article</h2>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>NO</th>
            <th>Title</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of selectedArticleRelate.related; let index = index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ row.title }}</td>
              <td>
                <button class="btn btn-sm btn-danger" (click)="handleDeleteRelatedArticle(row)"><i
                    class="fa-solid fa-trash"></i></button>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="selectedArticleRelate.related.length == 0">
            <td colspan="3" class="text-center text-bold">No items to remove</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>